import { useTranslation } from 'react-i18next';

import KitoBuddy from '../../../components/Buddy';
import KitoContentSection from '../../../components/DataDisplay/ContentSection';

export default function WhenToWorry({ title, disclaimer, options = [] }) {
  const { t } = useTranslation();
  return (
    <>
      <KitoBuddy image="whenToWorry">{t(title)}</KitoBuddy>
      <KitoContentSection variant="red-border" title={t(disclaimer)}>
        <div className="when__options">
          <ul>
            {options.map((option) => (
              <li key={option}>{t(option)}</li>
            ))}
          </ul>
        </div>
      </KitoContentSection>
    </>
  );
}
